import { Id } from "PFTypes";

export const phasesKeys = {
  all: () => ["phases"],
  byActivity: (activityId?: Id | null) => [...phasesKeys.all(), "byActivity", activityId]
};
